export default {
	title: "Glücksrad",
	Lucky: "Glücklich",
	wheels: "Räder",
	winningrecord: "Gewinnrekord",
	ActivityRules: "Aktionsregeln",
	ActivityRulesContent: "Für weitere Informationen zur Verlosung kontaktieren Sie bitte unseren Kundenservice.",
	award: {
		title: "Herzlichen Glückwunsch zum Gewinn!",
		btn: "Preis erhalten"
	},
	noticeItem: "{0} hat {1} erhalten",
	lotteryDraws: "{0} Lotterieziehungen",
	noAvailableTimes: "Unzureichende verfügbare Versuche. Bitte kontaktieren Sie den Kundenservice.",
	noOpen: "Noch nicht geöffnet",
	noWinning: "Weiterhin viel Erfolg",
	ViewALlPrizes: "Alle Preise anzeigen",
	myPrizes: "Meine Preise",
	share: "Mit einem Freund teilen"
};
